import React from 'react';
import { Link } from 'react-router-dom';

export default function Trending() {
  return (
    <section className="trending">
      <div className="container">
        <div className="trending-content">
          <h2 className="trending-title">What's trending now</h2>
          <ul className="trending-grid">
            <li className="trending-item">
              <Link to="/">
                <figure>
                  <img
                    src="./images/landing/tone-master.jpg"
                    className="img-flex"
                  />
                  <figcaption className="item-caption">
                    Tone Master Amplifiers
                  </figcaption>
                </figure>
              </Link>
            </li>
            <li className="trending-item">
              <Link to="/">
                <figure>
                  <img
                    src="./images/landing/Vintera-Series.jpg"
                    className="img-flex"
                  />
                  <figcaption className="item-caption">
                    Vintera Series
                  </figcaption>
                </figure>
              </Link>
            </li>
            <li className="trending-item">
              <Link to="/">
                <figure>
                  <img
                    src="./images/landing/classic-vibe.jpg"
                    className="img-flex"
                  />
                  <figcaption className="item-caption">
                    Squire Classic Vibe
                  </figcaption>
                </figure>
              </Link>
            </li>
            <li className="trending-item">
              <Link to="/">
                <figure>
                  <img
                    src="./images/landing/effects-pedals.jpg"
                    className="img-flex"
                  />
                  <figcaption className="item-caption">
                    Effects Pedals
                  </figcaption>
                </figure>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
